import CommonService from "../Common";
import { AxiosRequestConfig } from "axios";

interface GenerateStrategyRequestFormData {
  basicInfo: Object;
  contentStrategy: Object;
  growthGoals: Object;
  marketingResources: Object;
}

interface GenerateStrategyRequest {
  userId: string;
  formData: GenerateStrategyRequestFormData;
}

interface ContentStrategy {
  pathPrefix?: string;
  commonService: CommonService;
}

class ContentStrategyService implements ContentStrategy {
  pathPrefix?: string;
  commonService: CommonService;

  constructor() {
    this.pathPrefix = "/api/v1/contentstrategy";
    this.commonService = new CommonService();
  }

  generateStrategy(generationPayload: GenerateStrategyRequest) {
    const config: AxiosRequestConfig = {
      method: "POST",
      url: `${this.pathPrefix}/generate`,
      data: generationPayload,
      withCredentials: true,
    };
    return this.commonService.fetch(config);
  }
}

export default ContentStrategyService;
